export class UpdatesService {
    static $inject = ['BlipToastService', '$translate', '$window'];
    constructor(BlipToastService, $translate, $window) {
        'ngInject';
        this.BlipToastService = BlipToastService;
        this.$translate = $translate;
        this.$window = $window;
        this.minimumTimeToShowToast = 7500;
    }
    onUpdate(settings) {
        if (this.wasToastAlreadyShown() ||
            this.wasFeatureToggleInitilializedRecently()) {
            return;
        }
        let hasChange = false;
        for (const key of Object.keys(settings)) {
            if (settings[key].previous !== undefined &&
                settings[key].current !== undefined &&
                settings[key].previous !== settings[key].current) {
                hasChange = true;
                break;
            }
        }
        if (!hasChange) {
            return;
        }
        this.showNotification();
        this.$window.sessionStorage.setItem('update-toast-shown', 'true');
    }
    showNotification() {
        const title = this.$translate.instant('updateService.title');
        const msg = this.$translate.instant('updateService.message');
        const buttonText = this.$translate.instant('updateService.buttonText');
        const callback = () => {
            this.$window.sessionStorage.removeItem('update-toast-shown');
            location.reload();
        };
        this.BlipToastService.show('refresh', {
            title,
            msg,
            buttonText,
            callback,
            duration: 0,
        });
    }
    wasToastAlreadyShown() {
        return this.$window.sessionStorage.getItem('update-toast-shown') === 'true';
    }
    wasFeatureToggleInitilializedRecently() {
        const initialization = this.$window.sessionStorage.getItem('feature-toggle-initialization-timespan');
        if (!initialization) {
            return true;
        }
        return Date.now() < Number.parseInt(initialization) + this.minimumTimeToShowToast;
    }
}
UpdatesService.$inject = ['BlipToastService', '$translate', '$window'];
